import { useState, useEffect } from "react";
import { useNotification } from "../../../context/NotificationContext";
import { useLoader } from "../../../context/LoaderContext";
import AuthService from "../../../api/authService";

export default function ResetPasswordForm({ onSwitch }) {
  const [token, setToken] = useState("");
  const [formData, setFormData] = useState({
    new_password: "",
    confirm_password: "",
  });
  const { showNotification } = useNotification();
  const { showLoader, hideLoader } = useLoader();

  // ✅ Récupère le token depuis le hash de l’URL
  useEffect(() => {
    const hash = window.location.hash;
    const params = new URLSearchParams(window.location.hash.replace("#reset?", ""));
    const tokenValue = params.get("token");
    setToken(tokenValue || "");
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      showNotification("error", "Lien invalide ou expiré.");
      return;
    }

    if (formData.new_password !== formData.confirm_password) {
      showNotification("warning", "Les mots de passe ne correspondent pas.");
      return;
    }

    showLoader("form-wrapper");
    try {
      const res = await AuthService.resetPassword({
        token,
        new_password: formData.new_password,
        confirm_password: formData.confirm_password,
      });

      showNotification("success", res.message || "Mot de passe réinitialisé !");
      onSwitch("login");
    } catch (error) {
      showNotification(
        "error",
        error.response?.data?.error || "Erreur lors de la réinitialisation."
      );
    } finally {
      hideLoader();
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <p className="text-gray-600 text-center text-sm">
        Saisis ton nouveau mot de passe pour ton compte.
      </p>

      <div>
        <label className="block text-sm font-medium mb-1">
          Nouveau mot de passe
        </label>
        <input
          type="password"
          name="new_password"
          value={formData.new_password}
          onChange={handleChange}
          required
          className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-400 outline-none"
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-1">
          Confirmer le mot de passe
        </label>
        <input
          type="password"
          name="confirm_password"
          value={formData.confirm_password}
          onChange={handleChange}
          required
          className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-400 outline-none"
        />
      </div>

      <button
        type="submit"
        className="w-full bg-green-500 text-white py-2 rounded-lg hover:bg-green-600 transition duration-300"
      >
        Changer le mot de passe
      </button>

      <p className="text-center mt-6 text-gray-600">
        <button
          type="button"
          onClick={() => onSwitch("login")}
          className="text-green-600 font-semibold hover:underline"
        >
          Retour à la connexion
        </button>
      </p>
    </form>
  );
}
